<template>
  <el-container>
    <el-aside width="270px"
              style="background-color: rgb(238, 241, 246)">
      <el-menu :default-active="prntPath($route.path)">
        <el-menu-item index="admin"
                      @click="pushToAdmin">
          <i class="el-icon-menu"></i>
          <span>User List</span>

        </el-menu-item>

        <el-menu-item index="docs" style="height: 60px; line-height: 20px;"
                      @click="uploadChangeDoc">
          <i class="el-icon-menu"></i>
          <span>Marketing & Editorial
         Tips and <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
         Documents</span>

        </el-menu-item>


        <el-menu-item index="mail"
                      @click="$router.push('/admin/faqs')">
          <i class="el-icon-message"></i>
          <span>FAQs</span>
        </el-menu-item>
        <el-menu-item index="mail"
                      @click="$router.push('/admin/mail')">
          <i class="el-icon-message"></i>
          <span>Mail</span>
        </el-menu-item>
        <el-menu-item index="mail"
                      @click="$router.push('/admin/boards')">
          <i class="el-icon-message"></i>
          <span>Ask Questions</span>
        </el-menu-item>
      </el-menu>
      <div v-if="showUserAside"
           class="userNameField">{{userName}}</div>
      <el-menu :default-active="prntPath($route.path)">
        <el-menu-item v-if="showUserAside"
                      index="profile"
                      @click="$router.push(`/admin/${$route.params.userID}/profile`)">
          <i class="el-icon-info"></i>
          <span>Profile</span>
        </el-menu-item>
        <el-menu-item v-if="showUserAside"
                      index="files"
                      @click="$router.push(`/admin/${$route.params.userID}/files`)">
          <i class="el-icon-message"></i>
          <span>Royalty Statement</span>
        </el-menu-item>
        <el-menu-item v-if="showUserAside"
                      index="templates"
                      @click="$router.push(`/admin/${$route.params.userID}/templates`)">
          <i class="el-icon-message"></i>
          <span>Bank/Tax Templates</span>
        </el-menu-item>
        <el-menu-item v-if="showUserAside"
                      index="documents"
                      @click="$router.push(`/admin/${$route.params.userID}/documents`)">
          <i class="el-icon-message"></i>
          <span>Bank/Tax Documents</span>
        </el-menu-item>
        <el-menu-item v-if="showUserAside"
                      index="markets" class="high-menu-item"
                      @click="$router.push(`/admin/${$route.params.userID}/markets`)">
          <i class="el-icon-message"></i>
          <span>Marketing & Editorial <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tips and Documents</span>
        </el-menu-item>
        <!--
        <el-menu-item v-if="showUserAside"
                      index="documents"
                      @click="$router.push(`/admin/${$route.params.userID}/topics`)">
          <i class="el-icon-message"></i>
          <span>Talk</span>
        </el-menu-item>
        -->
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
export default {
  created() {
    this.checkIfUser();
  },
  data() {
    return {
      showUserAside: false,
      userName: '',
    };
  },
  watch: {
    $route(to, from) {
      this.checkIfUser();
    },
  },
  methods: {
    checkIfUser() {
      this.userName = localStorage.userName;
      if (this.$route.params.userID) this.showUserAside = true;
      else this.showUserAside = false;
    },
    prntPath(path) {
      return path.substring(path.lastIndexOf('/') + 1);
    },
    pushToAdmin() {
      this.$router.push(
        `/admin/list/${localStorage.page ? localStorage.page : 1}`
      );
    },
    uploadChangeDoc() {
      this.$router.push(
        '/admin/markets/'
      );
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'theme/element-variables';
.high-menu-item {
  height: 30px;
  line-height: 1;
}
.userNameField {
  text-align: center;
  background-color: #fff;
  border-right: solid 1px #e6e6e6;
  margin: 8px 0 1px 0;
  padding: 20px 0;
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/AdminLayout.vue